"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var text_1 = require("./text");
var styled_system_1 = require("styled-system");
var headings = styled_system_1.variant({ key: "Heading" });
exports.Heading = styled_1.default(text_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), headings);
exports.Heading.defaultProps = {
    as: "h1"
};
exports.Heading.displayName = "Heading";
var templateObject_1;
